<template>
  <div class="cargo-page">
    <el-row type="flex" justify="center">
      <el-col :span="22" :xs="23">
        <header class="cargo-page__hero">
          <div class="cargo-page__hero-text">
            <h1 class="cargo-page__title">Ачаа</h1>
            <p class="cargo-page__subtitle">Бүртгэлээс сонгож дэлгэрэнгүй харах</p>
          </div>
          <div v-if="cargoList.length" class="cargo-page__count">
            <span class="cargo-page__count-num">{{ filteredCargoList.length }}</span>
            <span class="cargo-page__count-label">{{ paymentFilterCountLabel }}</span>
            <span v-if="paymentFilter !== 'all'" class="cargo-page__count-sub">нийт {{ cargoList.length }}</span>
          </div>
        </header>

        <div v-if="cargoList.length" class="cargo-page__stats">
          <div
            v-if="checkPermissionsPage('app_cargo_yuan')"
            class="cargo-page__stat"
          >
            <span class="cargo-page__stat-label">Нийт юань</span>
            <span class="cargo-page__stat-value">{{ formatStatYuan(statsFiltered.sumYuan) }}</span>
          </div>
          <div
            v-if="checkPermissionsPage('app_cargo_price')"
            class="cargo-page__stat"
          >
            <span class="cargo-page__stat-label">Нийт төгрөг</span>
            <span class="cargo-page__stat-value">{{ formatStatMnt(statsFiltered.sumPrice) }}</span>
          </div>
          <div class="cargo-page__stat">
            <span class="cargo-page__stat-label">Нийт мкуб</span>
            <span class="cargo-page__stat-value">{{ formatStatMkub(statsFiltered.sumMkub) }}</span>
          </div>
          <div class="cargo-page__stat">
            <span class="cargo-page__stat-label">Нийт гаргасан</span>
            <span class="cargo-page__stat-value">{{ formatStatCount(statsFiltered.sumCount) }}</span>
          </div>
        </div>

        <div v-if="cargoList.length" class="cargo-page__filters">
          <span class="cargo-page__filters-label">Төлбөр</span>
          <el-radio-group v-model="paymentFilter" size="small" class="cargo-page__filter-group">
            <el-radio-button label="all">Бүгд ({{ paymentCountAll }})</el-radio-button>
            <el-radio-button label="unpaid">Тооцоо хийгээгүй ({{ paymentCountUnpaid }})</el-radio-button>
            <el-radio-button label="paid">Тооцоо хийсэн ({{ paymentCountPaid }})</el-radio-button>
          </el-radio-group>
        </div>

        <div class="cargo-page__toolbar">
          <el-button
            v-if="checkPermissionsPage('app_cargo_achaa_uusgeh')"
            type="success"
            size="medium"
            icon="el-icon-plus"
            class="cargo-page__toolbar-btn"
            @click="crudCargoDetailDialogOpen(null)"
          >
            Ачаа үүсгэх
          </el-button>
          <el-button
            v-if="checkPermissionsPage('yuanchange')"
            type="primary"
            plain
            size="medium"
            icon="el-icon-coin"
            class="cargo-page__toolbar-btn"
            @click="yuanDialogOpen"
          >
            Ханш
          </el-button>
        </div>

        <el-empty
          v-if="!cargoList.length && !$root.fullscreenLoading"
          class="cargo-page__empty"
          description="Одоогоор ачааны бүртгэл алга"
          :image-size="88"
        />

        <el-empty
          v-else-if="cargoList.length && !filteredCargoList.length && !$root.fullscreenLoading"
          class="cargo-page__empty"
          description="Сонгосон шүүлтэнд тохирох бүртгэл алга"
          :image-size="88"
        />

        <div v-if="filteredCargoList.length" class="cargo-card-list">
          <el-card
            v-for="(item, index) in filteredCargoList"
            :key="item.id != null ? 'c-' + item.id : index"
            class="cargo-card br-20"
            shadow="hover"
            :body-style="{ padding: '0' }"
            @click.native="cargoDetailDialogOpen(item.id)"
          >
            <div class="cargo-card__accent" :class="'cargo-card__accent--' + statusAccentClass(item.status)"></div>

            <div class="cargo-card__body">
              <div class="cargo-card__head">
                <div class="cargo-card__id-wrap">
                  <span class="cargo-card__id-label">Дугаар</span>
                  <span class="cargo-card__id">#{{ item.id }}</span>
                </div>
                <el-tag v-if="item.status" :type="statusTagType(item.status)" size="small" effect="dark" class="cargo-card__status-tag">
                  {{ returnStatusValue(item.status) }}
                </el-tag>
              </div>

              <dl class="cargo-card__dl">
                <div v-if="item.createdAt" class="cargo-card__row">
                  <dt>Төлөвийн огноо</dt>
                  <dd>{{ item.createdAt.split('T')[0] }}</dd>
                </div>
                <div v-if="item.count != null && item.count !== ''" class="cargo-card__row">
                  <dt>Гаргасан тоо</dt>
                  <dd>{{ item.count }}</dd>
                </div>
                <div v-if="item.phone" class="cargo-card__row">
                  <dt>Утас</dt>
                  <dd>
                    <a :href="'tel:' + item.phone" class="cargo-card__phone" @click.stop>{{ item.phone }}</a>
                  </dd>
                </div>
                <div v-if="checkPermissionsPage('app_cargo_yuan') && item.yuan" class="cargo-card__row">
                  <dt>Юань</dt>
                  <dd>{{ item.yuan }}</dd>
                </div>
                <div v-if="checkPermissionsPage('app_cargo_price') && item.price" class="cargo-card__row">
                  <dt>Төгрөг</dt>
                  <dd>{{ item.price | formatCurrency() }}</dd>
                </div>
                <div v-if="checkPermissionsPage('app_cargo_company') && item.company_name" class="cargo-card__row">
                  <dt>Байгууллага</dt>
                  <dd>{{ item.company_name }}</dd>
                </div>
                <div v-if="checkPermissionsPage('app_cargo_branch') && item.branch" class="cargo-card__row">
                  <dt>Салбар</dt>
                  <dd>{{ item.branch }}</dd>
                </div>
              </dl>

              <div v-if="checkPermissionsPage('app_cargo_payment')" class="cargo-card__paid">
                <el-tag v-if="item.is_paid === false" type="danger" size="small" effect="plain">Тооцоо хийгээгүй</el-tag>
                <el-tag v-else-if="item.is_paid === true" type="success" size="small" effect="plain">Тооцоо хийсэн</el-tag>
              </div>
            </div>

            <div class="cargo-card__actions" @click.stop>
              <div
                class="cargo-card__pair"
                :class="{
                  'cargo-card__pair--single': !(
                    checkPermissionsPage('view_cargo_is_paid') && item.is_paid === false
                  )
                }"
              >
                <el-button
                  type="info"
                  plain
                  size="small"
                  icon="el-icon-view"
                  class="cargo-card__action-btn cargo-card__action-btn--half"
                  @click="cargoDetailDialogOpen(item.id)"
                >
                  Дэлгэрэнгүй
                </el-button>
                <el-button
                  v-if="checkPermissionsPage('view_cargo_is_paid') && item.is_paid === false"
                  type="success"
                  plain
                  size="small"
                  icon="el-icon-wallet"
                  class="cargo-card__action-btn cargo-card__action-btn--half"
                  @click="cargoPaymentDialogOpen(item)"
                >
                  Төлбөр
                </el-button>
              </div>
              <el-button
                v-if="checkPermissionsPage('app_cargo_create_cargo_process') && item.status !== 200"
                type="primary"
                size="small"
                icon="el-icon-edit-outline"
                class="cargo-card__action-btn"
                @click="changeStatus(item.id)"
              >
                Явц оруулах
              </el-button>
              <el-button
                v-if="checkPermissionsPage('edit_cargo_china') && item.is_paid === false"
                type="warning"
                plain
                size="small"
                icon="el-icon-setting"
                class="cargo-card__action-btn"
                @click="crudCargoDetailDialogOpen(item.id)"
              >
                Засах
              </el-button>
            </div>
          </el-card>
        </div>
        <el-dialog
          :visible.sync="cargoPayment"
          :before-close="handleCloseCargoPayment"
          custom-class="cargo-payment-dialog"
          width="90%"
          append-to-body
          top="6vh"
        >
          <template slot="title">
            <div class="cargo-payment-dialog__head">
              <div class="cargo-payment-dialog__head-text">
                <span class="cargo-payment-dialog__kicker">Төлбөр</span>
                <span class="cargo-payment-dialog__id">#{{ selectedCargo.id }}</span>
              </div>
              <el-tag
                v-if="checkPermissionsPage('app_cargo_payment') && selectedCargo.is_paid === false"
                type="danger"
                size="small"
                effect="dark"
              >
                Тооцоо хийгээгүй
              </el-tag>
              <el-tag
                v-else-if="checkPermissionsPage('app_cargo_payment') && selectedCargo.is_paid === true"
                type="success"
                size="small"
                effect="dark"
              >
                Тооцоо хийсэн
              </el-tag>
            </div>
          </template>
          <div class="cargo-payment-dialog__body">
            <div class="cargo-payment-dialog__panel">
              <dl class="cargo-payment-dialog__dl">
                <div v-if="checkPermissionsPage('app_cargo_yuan') && selectedCargo.yuan" class="cargo-payment-dialog__row">
                  <dt>Юань</dt>
                  <dd>{{ selectedCargo.yuan | formatCurrencyYuan() }}</dd>
                </div>
                <div v-if="selectedCargo.price" class="cargo-payment-dialog__row">
                  <dt>Төгрөг</dt>
                  <dd class="cargo-payment-dialog__dd-strong">{{ selectedCargo.price | formatCurrency() }}</dd>
                </div>
                <div v-if="selectedCargo.count != null && selectedCargo.count !== ''" class="cargo-payment-dialog__row">
                  <dt>Гаргасан тоо</dt>
                  <dd>{{ selectedCargo.count }}</dd>
                </div>
                <div
                  v-if="checkPermissionsPage('app_cargo_company') && selectedCargo.Company && selectedCargo.Company.company_name"
                  class="cargo-payment-dialog__row"
                >
                  <dt>Байгууллага</dt>
                  <dd>{{ selectedCargo.Company.company_name }}</dd>
                </div>
                <div v-if="checkPermissionsPage('app_cargo_branch') && selectedCargo.branch" class="cargo-payment-dialog__row">
                  <dt>Салбар</dt>
                  <dd>{{ selectedCargo.branch }}</dd>
                </div>
              </dl>
            </div>
            <div class="cargo-payment-dialog__actions">
              <div class="cargo-payment-dialog__switch-row">
                <span class="cargo-payment-dialog__switch-label">Төлбөр төлөгдсөн</span>
                <el-switch
                  v-model="selectedCargo.is_paid"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="Тийм"
                  inactive-text="Үгүй"
                  :active-value="true"
                  :inactive-value="false"
                />
              </div>
              <el-button
                type="success"
                size="medium"
                icon="el-icon-check"
                class="cargo-payment-dialog__btn"
                :disabled="isPaidDisable()"
                @click="changeIsPaid()"
              >
                Тооцоо хийх
              </el-button>
            </div>
          </div>
        </el-dialog>
      </el-col>
      <CargoDetail v-if="$root.cargoDetailDialog" :selectedCargoDetail="cargoDetail" />
      <CrudCargoDetail
        v-if="$root.crudCargoDetailDialog"
        :selectedCargoDetailId="cargoDetailId"
        :isShowImage="img"
      />
    </el-row>
  </div>
</template>
<script>
import services from '@/helpers/services'
import { checkPermissions } from '@/helpers/custom'
import CargoDetail from '@/views/Dialog/CargoDetailDialog.vue'
import CrudCargoDetail from '@/views/Dialog/CrudCargoDetailDialog.vue'

export default {
  name: 'CargoPage',
  data () {
    return {
      cargoList: [],
      cargoDetail: {},
      cargoDetailId: null,
      cargoPayment: false,
      selectedCargo: {},
      img: null,
      paymentFilter: 'all'
    }
  },
  components: {
    CargoDetail,
    CrudCargoDetail
  },
  computed: {
    paymentCountAll () {
      return this.cargoList.length
    },
    paymentCountUnpaid () {
      return this.cargoList.filter((i) => i.is_paid !== true).length
    },
    paymentCountPaid () {
      return this.cargoList.filter((i) => i.is_paid === true).length
    },
    filteredCargoList () {
      if (this.paymentFilter === 'paid') {
        return this.cargoList.filter((i) => i.is_paid === true)
      }
      if (this.paymentFilter === 'unpaid') {
        return this.cargoList.filter((i) => i.is_paid !== true)
      }
      return this.cargoList
    },
    paymentFilterCountLabel () {
      if (this.paymentFilter === 'paid') return 'төлсөн'
      if (this.paymentFilter === 'unpaid') return 'төлөгдөөгүй'
      return 'бүртгэл'
    },
    statsFiltered () {
      let sumYuan = 0
      let sumPrice = 0
      let sumMkub = 0
      let sumCount = 0
      for (const i of this.filteredCargoList) {
        const y = Number(i.yuan)
        if (Number.isFinite(y)) sumYuan += y
        const p = Number(i.price)
        if (Number.isFinite(p)) sumPrice += p
        const m = Number(i.mkub)
        if (Number.isFinite(m)) sumMkub += m
        const c = Number(i.count)
        if (Number.isFinite(c)) sumCount += c
      }
      return { sumYuan, sumPrice, sumMkub, sumCount }
    }
  },
  created () {
    this.loadData()
  },
  mounted () {
    this.$root.cargoDetailDialog = false
    this.$root.crudCargoDetailDialog = false
    this.cargoPayment = false
  },
  watch: {
    '$root.crudCargoDetailDialog' (open, wasOpen) {
      if (wasOpen === true && open === false) {
        this.loadData()
      }
    }
  },
  methods: {
    handleCloseCargoPayment (done) {
      this.cargoPayment = false
      if (typeof done === 'function') {
        done()
      }
    },
    cargoPaymentDialogOpen (data) {
      this.selectedCargo = data
      this.cargoPayment = true
    },
    async loadData () {
      this.$root.fullscreenLoading = true
      services.getCargoProgress()
        .then((response) => {
          if (response.type === 'success') {
            this.cargoList = response.data
            this.$root.fullscreenLoading = false
          }
          this.$root.fullscreenLoading = false
        })
        .catch((error) => {
          alert(error)
          this.$root.fullscreenLoading = false
        })
    },
    returnStatusValue (data) {
      const result = this.$root.cargoStatus.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    formatStatYuan (n) {
      if (!Number.isFinite(n)) return '—'
      return new Intl.NumberFormat('mn-MN', { maximumFractionDigits: 2 }).format(n) + ' ¥'
    },
    formatStatMnt (n) {
      if (!Number.isFinite(n)) return '—'
      return new Intl.NumberFormat('mn-MN').format(Math.round(n)) + ' ₮'
    },
    formatStatMkub (n) {
      if (!Number.isFinite(n)) return '—'
      return new Intl.NumberFormat('mn-MN', { maximumFractionDigits: 3 }).format(n) + ' м³'
    },
    formatStatCount (n) {
      if (!Number.isFinite(n)) return '—'
      return new Intl.NumberFormat('mn-MN', { maximumFractionDigits: 2 }).format(n)
    },
    statusTagType (status) {
      const map = {
        130: 'success',
        100: 'primary',
        110: 'warning',
        140: 'danger'
      }
      return map[status] || 'info'
    },
    statusAccentClass (status) {
      const map = {
        130: 'success',
        100: 'primary',
        110: 'warning',
        140: 'danger'
      }
      return map[status] || 'muted'
    },
    async cargoDetailDialogOpen (data) {
      try {
        this.$root.fullscreenLoading = true
        await services.getCargoProgressById(data)
          .then((response) => {
            if (response.type === 'success') {
              this.cargoDetail = response.data
              this.$root.fullscreenLoading = false
            }
          }).catch((error) => {
            this.error = error
            console.error('Алдаа:', error)
            this.$root.fullscreenLoading = false
          })
      } catch (error) {
        alert(error)
        console.error('Алдаа:', error)
        this.$root.fullscreenLoading = false
      }
      this.$root.cargoDetailDialog = true
      this.$root.fullscreenLoading = false
    },
    async changeStatus (data) {
      this.cargoDetailId = data
      this.img = false
      this.$root.crudCargoDetailDialog = true
    },
    async crudCargoDetailDialogOpen (data) {
      this.cargoDetailId = data
      this.$root.crudCargoDetailDialog = true
    },
    yuanNotifyError (message) {
      this.$notify({
        title: 'Ханш шинэчлэхэд алдаа',
        message,
        type: 'error',
        duration: 9000,
        showClose: true
      })
    },
    async yuanDialogOpen () {
      this.$root.fullscreenLoading = true
      try {
        const response = await services.getYuan()
        if (response.type !== 'success') {
          throw new Error(response.error || 'Ханш авахад алдаа гарлаа')
        }
        const d = response.data || {}
        const id = d.id
        const suggested = response.suggested_yuan_price
        const meta = response.suggested_meta || {}
        const rate = Number(suggested)
        if (!id) {
          this.yuanNotifyError(
            '«Yuans» хүснэгтэд бүртгэл байхгүй байна. Эхлээд ханшийн мөр үүсгэнэ үү (серверийн админ).'
          )
          return
        }
        if (!Number.isFinite(rate) || rate <= 0) {
          const detail =
            meta.error != null && String(meta.error).trim() !== ''
              ? String(meta.error).trim()
              : 'Ханшийн санал ирээгүй. Серверийн лог болон сүлжээний тохиргоог шалгана уу.'
          this.yuanNotifyError(detail)
          return
        }
        const postRes = await services.postYuan({ id, yuan_price: rate })
        if (postRes.type === 'success') {
          const n = Array.isArray(postRes.cargos) ? postRes.cargos.length : 0
          this.$notify({
            title: 'Амжилттай',
            message: 'Банкны ханш ' + rate + ' ₮ хэрэгжлээ. Төлөгдөөгүй ' + n + ' ачаа шинэчлэгдлээ.',
            type: 'success',
            duration: 4000
          })
          this.loadData()
        } else {
          throw new Error(postRes.error || 'Ханш хадгалахад алдаа гарлаа')
        }
      } catch (e) {
        const msg =
          typeof e === 'string' ? e : e && e.message ? e.message : 'Тодорхойгүй алдаа гарлаа.'
        this.yuanNotifyError(msg)
      } finally {
        this.$root.fullscreenLoading = false
      }
    },
    isPaidDisable () {
      if (this.selectedCargo.is_paid === true) {
        return false
      } else {
        return true
      }
    },
    changeIsPaid () {
      try {
        this.$root.fullscreenLoading = true
        const payload = { id: this.selectedCargo.id, is_paid: this.selectedCargo.is_paid }
        services.changeIsPaid(payload)
          .then((response) => {
            if (response.type === 'success') {
              this.$notify({
                title: 'Амжилттай',
                message: 'Төлбөр амжилттай төлөгдлөө',
                type: 'success',
                duration: 3000
              })
              this.cargoPayment = false
              this.loadData()
            }
          })
          .catch((error) => {
            this.error = error
            alert(error)
          })
          .finally(() => {
            this.$root.fullscreenLoading = false
          })
      } catch (error) {
        alert(error)
        this.$root.fullscreenLoading = false
      }
    }
  }
}
</script>
<style scoped>
.cargo-page {
  min-height: 100%;
  padding: env(safe-area-inset-top, 0px) 0 28px;
  background: linear-gradient(180deg, #f0f4f8 0%, #e8eef5 38%, #f5f7fa 100%);
}

.cargo-page__hero {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 4px 8px;
}

.cargo-page__title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: -0.02em;
  color: #1a2332;
}

.cargo-page__subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  color: #64748b;
  font-weight: 300;
}

.cargo-page__count {
  flex-shrink: 0;
  text-align: right;
  padding: 10px 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.cargo-page__count-num {
  display: block;
  font-size: 1.35rem;
  font-weight: 500;
  color: #0f172a;
  line-height: 1.2;
}

.cargo-page__count-label {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.cargo-page__count-sub {
  font-size: 11px;
  color: #94a3b8;
}

.cargo-page__stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 0 4px 14px;
}

@media (min-width: 520px) {
  .cargo-page__stats {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.cargo-page__stat {
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 14px;
  padding: 12px 14px;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
}

.cargo-page__stat-label {
  display: block;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 6px;
}

.cargo-page__stat-value {
  font-size: 1.05rem;
  font-weight: 500;
  color: #0f172a;
  line-height: 1.25;
  word-break: break-word;
}

.cargo-page__filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  padding: 4px 4px 14px;
}

.cargo-page__filters-label {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.cargo-page__filter-group {
  flex: 1 1 auto;
  min-width: 0;
}

.cargo-page__toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 8px 4px 16px;
}

.cargo-page__toolbar-btn {
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.12);
}

.cargo-page__toolbar-btn.el-button--success {
  box-shadow: 0 2px 10px rgba(103, 194, 58, 0.25);
}

.cargo-page__empty {
  padding: 32px 16px 8px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 16px;
  margin-bottom: 8px;
}

.cargo-card-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.cargo-card {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(148, 163, 184, 0.35) !important;
  border-radius: 18px !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.cargo-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.1) !important;
  border-color: rgba(64, 158, 255, 0.35) !important;
}

.cargo-card__accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 4px 0 0 4px;
}

.cargo-card__accent--success {
  background: linear-gradient(180deg, #67c23a, #85ce61);
}

.cargo-card__accent--primary {
  background: linear-gradient(180deg, #409eff, #66b1ff);
}

.cargo-card__accent--warning {
  background: linear-gradient(180deg, #e6a23c, #ebb563);
}

.cargo-card__accent--danger {
  background: linear-gradient(180deg, #f56c6c, #f78989);
}

.cargo-card__accent--muted {
  background: linear-gradient(180deg, #94a3b8, #cbd5e1);
}

.cargo-card__body {
  padding: 16px 16px 12px 18px;
}

.cargo-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.cargo-card__id-wrap {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.cargo-card__id-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
}

.cargo-card__id {
  font-size: 1.25rem;
  font-weight: 500;
  color: #0f172a;
}

.cargo-card__status-tag {
  border-radius: 8px !important;
}

.cargo-card__dl {
  margin: 0;
}

.cargo-card__row {
  display: grid;
  grid-template-columns: minmax(100px, 38%) 1fr;
  gap: 8px 12px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(226, 232, 240, 0.9);
}

.cargo-card__row:last-of-type {
  border-bottom: none;
}

.cargo-card__row dt {
  margin: 0;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 400;
}

.cargo-card__row dd {
  margin: 0;
  font-size: 14px;
  color: #334155;
  font-weight: 400;
  word-break: break-word;
}

.cargo-card__phone {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

.cargo-card__phone:hover {
  text-decoration: underline;
}

.cargo-card__paid {
  margin-top: 12px;
}

.cargo-card__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 14px 14px;
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.95), #f1f5f9);
  border-top: 1px solid rgba(226, 232, 240, 0.85);
}

.cargo-card__pair {
  display: flex;
  flex: 1 1 100%;
  gap: 8px;
  width: 100%;
}

.cargo-card__pair--single .cargo-card__action-btn--half {
  flex: 1 1 100%;
}

.cargo-card__pair .cargo-card__action-btn--half {
  flex: 1 1 0;
  min-width: 0;
}

.cargo-card__action-btn {
  flex: 1 1 auto;
  min-width: 0;
  border-radius: 10px !important;
}
</style>

<style>
.cargo-payment-dialog.el-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  max-width: 420px;
}

.cargo-payment-dialog .el-dialog__header {
  padding: 16px 18px 12px;
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 45%, #e8eef5 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.35);
}

.cargo-payment-dialog .el-dialog__title {
  width: 100%;
}

.cargo-payment-dialog .el-dialog__body {
  padding: 0 0 18px;
  background: #f8fafc;
}

.cargo-payment-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 12px;
}

.cargo-payment-dialog__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-right: 28px;
}

.cargo-payment-dialog__head-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.cargo-payment-dialog__kicker {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #047857;
}

.cargo-payment-dialog__id {
  font-size: 1.3rem;
  font-weight: 500;
  color: #0f172a;
}

.cargo-payment-dialog__body {
  padding: 14px 16px 0;
}

.cargo-payment-dialog__panel {
  background: #fff;
  border-radius: 14px;
  padding: 14px 16px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  margin-bottom: 14px;
}

.cargo-payment-dialog__dl {
  margin: 0;
}

.cargo-payment-dialog__row {
  display: grid;
  grid-template-columns: minmax(88px, 34%) 1fr;
  gap: 6px 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}

.cargo-payment-dialog__row:last-child {
  border-bottom: none;
}

.cargo-payment-dialog__row dt {
  margin: 0;
  font-size: 12px;
  color: #94a3b8;
}

.cargo-payment-dialog__row dd {
  margin: 0;
  font-size: 14px;
  color: #334155;
  word-break: break-word;
}

.cargo-payment-dialog__dd-strong {
  font-weight: 500;
  color: #0f172a;
}

.cargo-payment-dialog__actions {
  background: #fff;
  border-radius: 14px;
  padding: 14px 16px 16px;
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.cargo-payment-dialog__switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
}

.cargo-payment-dialog__switch-label {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
}

.cargo-payment-dialog__btn {
  width: 100%;
  border-radius: 12px !important;
}
</style>
